import React, { useState } from "react"
import {
  Card,
  Input,
  Button,
  CardBody,
  ListGroup,
  InputGroup,
  ListGroupItem,
  InputGroupAddon
} from "reactstrap"

import { ToggleBlock } from "components/ui-component"

const ProductCategroies = props => {
  const [isNavOpen, setIsNavOpen] = useState({})
  const [keyWord, setKeyWord] = useState("")
  const [selectedCategory, setSelectedCategory] = useState("")
  const [selectedSubCategory, setSelectedSubCategory] = useState("")

  const toggleMenu = id => {
    setIsNavOpen({ [id]: !isNavOpen[id] })
  }

  const renderCategories = category => {
    return (
      <ListGroupItem
        style={{ cursor: "pointer" }}
        onClick={() => toggleMenu(category.id)}
        className={isNavOpen[category.id] && "active"}
      >
        <strong>
          {category.name}
          <span>( {category.subcategories.length} )</span>
        </strong>

        {isNavOpen[category.id] ? (
          <i className="fas fa-chevron-down" />
        ) : (
          <i className="fas fa-chevron-right" />
        )}
      </ListGroupItem>
    )
  }

  const renderSubcategories = (category, isNavOpen) => {
    if (category.subcategories.length <= 0) {
      return null
    }

    return (
      <ToggleBlock isOpen={isNavOpen[category.id]}>
        <ListGroup className="pb-4">
          {category.subcategories
            .filter(subcategory => subcategory.isEnable)
            .map(subcategory => {
              return (
                <ListGroupItem
                  key={subcategory.name}
                  style={{ cursor: "pointer" }}
                  className={`border-0 link pl-3 ${
                    props.selectedCategory === subcategory.id ? "active" : ""
                  }`}
                  onClick={() => {
                    props.onCategoryChange(subcategory.id)
                  }}
                >
                  <a>{subcategory.name}</a>
                </ListGroupItem>
              )
            })}
        </ListGroup>
      </ToggleBlock>
    )
  }

  const renderCategoryOptions = data =>
    data.categories
      ?.filter(category => category.isEnable)
      .map(category => (
        <option key={category.id} value={category.id}>
          {category.name}
        </option>
      ))

  const renderSubcategoryOptions = data => {
    return (
      selectedCategory &&
      data.categories
        .filter(
          category => category.id === selectedCategory && category.isEnable
        )
        .map(item =>
          item.subcategories.map(subcategory => (
            <option value={subcategory.id} key={subcategory.id}>
              {subcategory.name}
            </option>
          ))
        )
    )
  }

  return (
    <>
      <div className="category-block d-none d-md-block">
        <Card className="category-block h-100">
          <CardBody className="p-2" style={{ color: "#9a9a9a" }}>
            <ListGroup flush>
              <ListGroupItem className="p-0 pb-2 border-0">
                <InputGroup>
                  <Input
                    placeholder="搜尋產品編號"
                    onChange={e => props.onSearchNumberClick(e.target.value)}
                  />
                </InputGroup>
              </ListGroupItem>
              <ListGroupItem className="p-0 pb-2 border-0">
                <InputGroup>
                  <Input
                    placeholder="搜尋產品名稱"
                    onChange={e => props.onSearchNameClick(e.target.value)}
                  />
                </InputGroup>
              </ListGroupItem>
              {props.categoriesData?.categories
                ?.filter(category => category.isEnable)
                .map(category => (
                  <div key={category.id}>
                    {renderCategories(category)}
                    {renderSubcategories(category, isNavOpen)}
                  </div>
                ))}
            </ListGroup>
          </CardBody>
        </Card>
      </div>

      <div className="d-block d-sm-block d-md-none">
        <Card className="category-block h-100">
          <CardBody className="p-2">
            <ListGroup flush>
              <ListGroupItem className="p-0 pb-3">
                <InputGroup>
                  <Input
                    placeholder="請輸入關鍵字搜尋"
                    value={keyWord}
                    onChange={e => setKeyWord(e.target.value)}
                  />
                  <InputGroupAddon addonType="prepend">
                    <Button onClick={() => props.onSearchClick(keyWord)}>
                      <i className="fas fa-search" />
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
              </ListGroupItem>
              <ListGroupItem className="border-0 p-0">
                <Input
                  type="select"
                  className="mb-2"
                  value={selectedCategory}
                  onChange={e => {
                    setSelectedCategory(e.target.value)
                    props.onCategoryChange(e.target.value)
                  }}
                >
                  <option value="">全部</option>
                  {renderCategoryOptions(props.categoriesData)}
                </Input>
              </ListGroupItem>
              <ListGroupItem className="border-0 p-0 mb-3">
                <Input
                  type="select"
                  value={selectedSubCategory}
                  onChange={e => {
                    setSelectedSubCategory(e.target.value)
                    props.onCategoryChange(e.target.value)
                  }}
                >
                  <option value="">全部</option>
                  {renderSubcategoryOptions(props.categoriesData)}
                </Input>
              </ListGroupItem>
            </ListGroup>
          </CardBody>
        </Card>
      </div>
    </>
  )
}

export default ProductCategroies
